<template>
  <b-card class="credit-search-card">

    <div class="search-header">
      <div>
        <div class="search-title">
          Análise de Crédito
        </div>

        <div class="search-subtitle">
          Pesquise uma empresa para iniciar ou consultar análises de crédito
        </div>
      </div>

      <b-button
        v-if="canViewParameters()"
        variant="secondary"
        class="parameters-button"
        @click="goToParameters"
      >
        <feather-icon
          icon="SettingsIcon"
          size="16"
          class="mr-50"
        />

        Parâmetros
      </b-button>
    </div>

    <b-input-group class="search-input">
      <b-form-input
        v-model="cnpj"
        v-mask="'##.###.###/####-##'"
        placeholder="00.000.000/0000-00"
        :disabled="loading"
        autocomplete="off"
        @keyup.enter="search"
      />

      <b-input-group-append>
        <b-button
          variant="link"
          :disabled="loading"
          @click="search"
        >
          <b-spinner
            v-if="loading"
            small
          />
          <feather-icon
            v-else
            icon="SearchIcon"
            size="20"
          />
        </b-button>
      </b-input-group-append>
    </b-input-group>

  </b-card>
</template>

<script>
import {
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BButton,
  BSpinner
} from 'bootstrap-vue'

export default {
  name: 'CreditSearch',

  components: {
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
    BSpinner
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    value: {
      type: String,
      default: ''
    }
  },

  computed: {
    cnpj: {
      get() {
        return this.value || ''
      },

      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    canViewParameters() {
      const permissions = this.$store.state.user?.data?.profile?.permissions || [];
      return permissions.includes(173);  
    },
    search() {
      if (!this.cnpj.trim()) {
        return
      }

      this.$emit('search', this.cnpj)
    },

    goToParameters() {
      this.$router.push({
        name: 'params'
      })
    }
  }
}
</script>

<style scoped>
.credit-search-card {
  border: 0;
  border-radius: 8px;
  margin-bottom: 16px;
}

.search-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-title {
  font-size: 20px;
  font-weight: 600;
}

.search-subtitle {
  font-size: 13px;
  margin-top: 2px;
}

.parameters-button {
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.search-input {
  width: 460px;
  margin: 18px auto 5px;
  border: 1px solid #d9d7df;
  border-radius: 7px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-input:focus-within {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(185, 183, 211, 0.712);
}

.search-input .form-control {
  height: 42px;
  border: 0;
  border-radius: 7px 0 0 7px;
  box-shadow: none;
}

.search-input .form-control:focus {
  border: 0;
  box-shadow: none;
}

.search-input .input-group-append {
  display: flex;
  align-items: center;
  border: 0;
}

.search-input button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 42px;
  padding: 0;
  border: 0;
  color: #8b8995;
  background: transparent;
  box-shadow: none;
}

.search-input button:focus,
.search-input button:active {
  border: 0;
  box-shadow: none;
}

@media (max-width: 768px) {
  .search-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .parameters-button {
    width: 100%;
  }

  .search-input {
    width: 100%;
  }
}
</style>